import { userService } from "@/_services/user.service"

export default {
  namespaced: true, 

  state: {
    userInfo: null,
    cardInfo: null
  },

  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload
    },

    setCardInfo(state, payload) {
      state.cardInfo = payload
    },

    setUserPhone(state, phone) {
      state.userInfo.other_phone = phone
    }
  },
  
  actions: {
    loadUserInfo({ commit }) {
      return userService.getProfileinfo().then(data => {
        commit('setUserInfo', data.kiddie_acc_info)
      })
    },

    loadCard({ commit }) {
      return userService.getCard().then(data => {
        commit('setCardInfo', data.accinfo)
      })
    },

    changeProfileInfo({ dispatch }, obj){
      return userService.changeProfileInfo(obj).then(() => {
        dispatch('loadUserInfo')
      })
    }
  }
  
}